import type { RevisionDiffDetailBox } from 'features/knowledgeDocumentViewer/hooks/useRevisionDiffDetails'

const MIN_BOX_SPAN = 0.001

export function boxSpan(low: number, high: number): number {
  return Math.min(1, Math.max(high - low, MIN_BOX_SPAN))
}

export function cropCanvasSize({
  cropW,
  cropH,
  maxIntrinsic,
}: {
  cropW: number
  cropH: number
  maxIntrinsic: number
}): { canvasWidth: number; canvasHeight: number } {
  const intrinsicScale = Math.min(1, maxIntrinsic / Math.max(cropW, cropH))
  return {
    canvasWidth: Math.max(1, Math.round(cropW * intrinsicScale)),
    canvasHeight: Math.max(1, Math.round(cropH * intrinsicScale)),
  }
}

/** CSS background size/position (percent) that frames `box` in a full-page image. */
export function cropFallbackBackground(box: RevisionDiffDetailBox): {
  sizeX: number
  sizeY: number
  posX: number
  posY: number
} {
  const widthFraction = boxSpan(box.x0, box.x1)
  const heightFraction = boxSpan(box.y0, box.y1)
  return {
    sizeX: 100 / widthFraction,
    sizeY: 100 / heightFraction,
    posX: widthFraction >= 1 ? 0 : (box.x0 / (1 - widthFraction)) * 100,
    posY: heightFraction >= 1 ? 0 : (box.y0 / (1 - heightFraction)) * 100,
  }
}
